import { ref } from 'vue'

const activeId = ref<null | string>(null)

type TUseFocus = {
  isFocused: (id: string) => boolean
  focus: (id: string) => void
  unfocus: () => void
}

export const useFocusManager = (): TUseFocus => {
  const isFocused = (id: string): boolean => {
    return activeId.value === id
  }

  const focus = (id: string): void => {
    activeId.value = id
  }

  const unfocus = (): void => {
    activeId.value = null
  }

  return {
    isFocused,
    focus,
    unfocus,
  }
}
